export {}

const mainNavs = document.querySelectorAll(".m-nav.--dynamic")

mainNavs.forEach((nav) => {
  function adjustMenuItems(): void {
    const container = nav.querySelector<HTMLElement>(".m-nav__list")
    const menuItems = Array.from(nav.querySelectorAll<HTMLElement>(".m-nav__list > .i-menu"))
    const submenuWrapper = nav.querySelector<HTMLElement>(".m-nav__dynamic-submenu-wrapper")
    const submenu = nav.querySelector<HTMLElement>(".m-nav__dynamic-submenu")

    if (!container || !menuItems || !submenuWrapper || !submenu) return
    // Helper function to calculate the true width of the container minus the space taken by submenu wrapper
    const getAvailableWidth = () => container.clientWidth - (submenu.children.length > 1 ? submenuWrapper.offsetWidth : 0)

    const getMenuItemTrueWidth = (item : HTMLElement) => {
      const menuLink = item?.querySelector<HTMLElement>(".i-menu__link")
      const menuTitle = item?.querySelector<HTMLElement>(".i-menu__title")
      if (!menuLink || !menuTitle) return 0
      const computedStyle = getComputedStyle(menuLink)
      const menuLinkOuterSize = ['paddingLeft', 'paddingRight', 'marginLeft', 'marginRight']
        .reduce((sum,  prop) => sum + parseFloat(computedStyle[prop]), 0);
      return menuTitle.offsetWidth + menuLinkOuterSize
    }

    // Helper function to calculate total width of menu items
    const getTotalMenuItemsWidth = () =>
      menuItems.reduce((total, item) => total + getMenuItemTrueWidth(item), 0)

    // Move items to submenu if container's width is insufficient
    const moveToSubmenu = () => {
      while (getTotalMenuItemsWidth() > getAvailableWidth()) {
        const lastMenuItem = menuItems.pop()!
        submenu.prepend(lastMenuItem)
        toggleSubmenuVisibility()
      }
    }

    // Move items back to main container if there's enough space
    const moveToMainMenu = () => {
      while (submenu.children.length > 0) {
        const submenuFirstItem = submenu.querySelector<HTMLElement>(".i-menu")
        if (!submenuFirstItem) return
        if (getTotalMenuItemsWidth() + getMenuItemTrueWidth(submenuFirstItem) > getAvailableWidth()) return
        submenuWrapper.before(submenuFirstItem)
        menuItems.push(submenuFirstItem)
        toggleSubmenuVisibility()
      }
    }

    // Show/hide submenu wrapper based on item count in submenu
    const toggleSubmenuVisibility = () => {
      submenuWrapper.classList.toggle("d-none", submenu.children.length == 0)
    }

    // Perform the menu item adjustments
    moveToSubmenu()
    moveToMainMenu()
  }

  // Call adjustMenuItems on window resize to make it dynamic
  window.addEventListener("resize", adjustMenuItems)

  // Call it on page load to ensure initial adjustment
  document.addEventListener("DOMContentLoaded", adjustMenuItems)
})
